<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button  type="success" plain @click="onExport" >导出</el-button>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/fund/contactcash/customerbill/list";
export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
    }
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.list.onExport();
      })
        .catch(() => {});
    },
  }
};
</script>